import React, {Component} from 'react';
import { Row, Col, Media, Label, Image } from 'react-bootstrap';
import image1 from '../images/fortepiano-no-shadow-02.png';

export default class News extends Component {
    render() {
        return (
            <div className="transition-item">

                <h1 className="text-muted text-center">2019</h1>

                <Media className="card">
                    <Media.Left>
                        <Image thumbnail={true} className="media-object" src="https://www.nmz.de/files/jumulogo_medium.jpg" alt="Jugend Musiziert" width="64"/>
                    </Media.Left>
                    <Media.Body>
                        <Media.Heading>Preisträger beim Musikwettbewerb "Jugend Musiziert" 2019 <small>03.02.2019</small></Media.Heading>
                        <p>
                            Wir gratulieren unseren diesjährigen Preisträgern beim Wettbewerb "Jugend Musiziert":
                        </p>
                        <ul>
                            <li>Anne-Sophie Fromentel &amp; Anastasia Krystopina: 1. Preis in der Wertung "Gesang-Duo"</li>
                        </ul>
                    </Media.Body>
                </Media>

                <h1 className="text-muted text-center">2018</h1>

                <Media className="card">
                    <Media.Left>
                        <Image thumbnail={true} className="media-object" src={image1} alt="Fortepiano Logo" width="64"/>
                    </Media.Left>
                    <Media.Body>
                        <Media.Heading>Website Relaunch <small>18.11.2018</small></Media.Heading>
                        <p>
                            Nach fast 10 Jahren wird die bereits etwas datierte Website generalüberholt.
                        </p>
                        <p>
                            Die neue Website basiert auf moderner Web-Technologie und ist nun endlich responsive - perfekte Usability, egal ob
                            auf dem Desktop, Tablet oder Smartphone!
                        </p>
                        <p>
                            Wir wünschen einen schönen Aufenthalt.
                        </p>
                    </Media.Body>
                </Media>
                <Media className="card">
                    <Media.Left>
                        <Image thumbnail={true} className="media-object" src="https://www.nmz.de/files/jumulogo_medium.jpg" alt="Jugend Musiziert" width="64"/>
                    </Media.Left>
                    <Media.Body>
                        <Media.Heading>Preisträger beim Musikwettbewerb "Jugend Musiziert" 2018 <small>27.01.2018</small></Media.Heading>
                        <p>
                            Wir gratulieren unseren diesjährigen Preisträgern beim Wettbewerb "Jugend Musiziert":
                        </p>
                        <ul>
                            <li>Anne-Sophie Fromentel (Klavier) &amp; Elise Fromentel (Geige): 1. Preis in der Wertung "Duo: Klavier und ein Streichinstrument"</li>
                        </ul>
                    </Media.Body>
                </Media>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/News.js